import Immutable from 'immutable';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { bibShape } from '@bibliocommons/bc-prop-types';

import { ExpandableList } from 'app/components/shared/Expandable';
import Heading from 'app/components/shared/Heading';
import FieldValue from 'app/components/bibs/shared/MetadataDisplay/FieldValue';
import './SubjectAndGenre.scss';

const MAX_ITEMS_DISPLAYED = 3;

export const fieldsShape = ImmutablePropTypes.listOf(
  ImmutablePropTypes.mapContains({
    fieldName: PropTypes.string,
    fieldValues: ImmutablePropTypes.listOf(
      ImmutablePropTypes.mapContains({
        primary: ImmutablePropTypes.mapContains({
          values: ImmutablePropTypes.listOf(PropTypes.string)
        })
      })
    )
  })
);

export default function SubjectAndGenre({ bib, fields, trackFieldItemClick }) {
  const contentType = bib.getIn(['briefInfo', 'contentType']);
  const acceptedContentTypes = ['NONFICTION', 'GOVERNMENT_DOCUMENTS', 'ARCHIVAL'];
  const isShowSubjectAndGenre = acceptedContentTypes.includes(contentType);
  if (!isShowSubjectAndGenre) {
    return null;
  }

  const allFieldValues = fields.flatMap(field => field.get('fieldValues', Immutable.List())) ?? Immutable.List();
  if (allFieldValues.size === 0) {
    return null;
  }

  const renderFieldValue = fieldValue => {
    const fieldItem = fields.find(field => field.get('fieldValues')?.indexOf(fieldValue) > -1) ?? Immutable.Map();
    return <FieldValue handleClick={() => trackFieldItemClick(fieldItem, fieldValue)} value={fieldValue} />;
  };

  const getItemKey = fieldValue => fieldValue.getIn(['primary', 'values', 0]);

  return (
    <div className="cp-subject-genre">
      <Heading tagName="h3" size="medium" variant>
        <FormattedMessage id="bib_metadata_category_subjectgenre" />
      </Heading>
      <ExpandableList
        list={allFieldValues}
        getItemKey={getItemKey}
        renderItem={renderFieldValue}
        collapseCount={MAX_ITEMS_DISPLAYED}
        expandLinkHref="#show-more-subject"
        stacked
        textKey="subject_and_genre"
      />
    </div>
  );
}

SubjectAndGenre.propTypes = {
  bib: bibShape.isRequired,
  fields: fieldsShape.isRequired,
  trackFieldItemClick: PropTypes.func.isRequired
};
